import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { MemberFormFields } from "./MemberFormFields";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Sparkles, Send } from "lucide-react";

const relLabel = { parent: "parent", spouse: "spouse / partner", child: "child", sibling: "sibling" };

export function SuggestPersonDialog({ open, onOpenChange, relateTo, relation, relateToName, onDone }) {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) setForm({}); }, [open]);

  const submit = async () => {
    if (!form.full_name?.trim()) return toast.error("Please enter a name");
    setBusy(true);
    try {
      const payload = { ...form };
      if (relateTo && relation) { payload.relate_to = relateTo; payload.relation = relation; }
      const res = await api.create(payload);
      toast.success(res?.pending ? (res.message || "Your suggestion was sent for review") : `${form.full_name} added`);
      onDone?.();
      onOpenChange(false);
    } catch {
      toast.error("Could not send your suggestion");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto" data-testid="suggest-person-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-serif text-2xl text-[#082D4A]"><Sparkles size={20} /> Suggest a person</DialogTitle>
          <DialogDescription>
            {relateTo ? `Suggest a ${relLabel[relation] || "relative"} for ${relateToName}. ` : ""}
            An admin will review and approve your suggestion before it appears on the tree.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <MemberFormFields form={form} setForm={setForm} />
        </div>
        <Button onClick={submit} disabled={busy} data-testid="suggest-submit-button" className="mt-6 w-full rounded-full bg-[#D4A017] py-6 text-base text-white hover:bg-[#B0850F]">
          <Send size={16} className="mr-2" /> {busy ? "Sending…" : "Send suggestion"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
